import { Col, Form, Input } from "antd";

const DigitalDefectRecommendationFilter = ({ initialTableData }) => {
  return (
    <>
      <Col span={4}>
        <Form.Item label="Recommendation" name="name">
          <Input placeholder="recommendation" size="small" />
        </Form.Item>
      </Col>
    </>
  );
};

export default DigitalDefectRecommendationFilter;
